import React, { useEffect, useState } from "react";
import Header from "../components/header";
import SideBar from "../components/SideBar";
import Settings from "../pages/Setting";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AnimatePresence, motion } from "framer-motion";
import { IoCloseOutline } from "react-icons/io5";
import DoctorDetails from "../components/DoctorDetails";
import { useSidebar } from "../../clinic/context/ClinicContext";
import PatientProfilePage from "../pages/PatientProfilePage";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { getPatientDetailsWithContactInfo } from "../services/api";
import { calculateAgeR } from "../utils/commonUtils";
import BillingForm from "../pages/BillingForm";
import EMRSettings from "../pages/EMRSettings";

const Layout = ({ children }) => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [callApi, setCallAPi] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [showBillingForm, setShowBillingForm] = useState(false);
  const [selectedPatientNew, setSelectedPatientNew] = useState(null);

  const {
    selectedSuggestion,
    handleSuggestion,
    selectedPatient,
    setSelectedPatient,
  } = useSidebar();

  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);

  const location = useLocation();
  const settingSideBarShow =
    location.pathname === "/clinic/setting" ||
    location.pathname === "/clinic/UserProfile" ||
    location.pathname === "/clinic/service" ||
    location.pathname === "/clinic/ClinicProfile" ||
    location.pathname === "/clinic/EMRSettings";

  useEffect(() => {
    if (selectedSuggestion && selectedSuggestion?.doctor_id) {
      setSelectedDoctor(selectedSuggestion);
    } else if (selectedSuggestion && selectedSuggestion?.patient_id) {
      const fetchData = async (patient_id) => {
        const data = await getPatientDetailsWithContactInfo(patient_id);
        console.log("datadata", data);
        if (data) {
          const patient = {
            patient_id: data?.patient?.patient_id,
            user_id: data?.patient?.userDetails?.user_id,
            name:
              data?.patient?.userDetails?.first_name +
              " " +
              data?.patient?.userDetails?.last_name,
            age: calculateAgeR(data?.patient?.userDetails?.date_of_birth),
            gender: data?.patient?.userDetails?.gender,
            primary_phone_number: data?.primary_phone_number,
          };

          setSelectedPatientNew(patient);
          setCallAPi(false);
        }
      };
      if (callApi) {
        fetchData(selectedSuggestion?.patient_id);
      }
    }
  }, [callApi]);
  useEffect(() => {
    if (selectedSuggestion) {
      setCallAPi(true);
    } else if (selectedSuggestion == null) {
      setCallAPi(false);
    }
  }, [selectedSuggestion]);

  const closeDoctorHandel = () => {
    setSelectedDoctor(null);
    handleSuggestion(null);
  };

  const handleCreateBill = (patientId) => {
    setSelectedPatientId(patientId);
    setShowBillingForm(true);
  };

  const closePateintHandel = () => {
    setSelectedPatientNew(null);
    handleSuggestion(null);
  };

  const handleCloseBillingForm = () => {
    setSelectedPatientId(null);
    setShowBillingForm(false);
  };
  return (
    <div className="app-layout-classic flex flex-auto flex-col bg-[#F4F5F5]">
      <div className="flex flex-auto min-w-0">
        <SideBar />
        <div
          className={`flex flex-col flex-auto min-h-screen min-w-0 relative w-full transition-width duration-600 ${
            settingSideBarShow ? "md:ml-32" : "md:ml-16"
          }`}
        >
          <Header />
          {settingSideBarShow && <Settings />}

          <div className="h-full flex flex-auto flex-col  pt-[70px]">
            <div className="h-full flex flex-auto flex-col justify-between">
              <main className="h-full">{children}</main>

              <AnimatePresence>
                {selectedDoctor && (
                  <>
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      className=" bg-black/5 absolute w-[calc(100%+65px)] h-full top-0 -left-[65px] z-40"
                    ></motion.div>
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      className={`bg-white shadow-md rounded-none fixed right-0 top-0 h-full z-40 w-full lg:w-[calc(100%-322px)] xl:w-[calc(100%-65%)] 2xl:w-[calc(100%-65%)]`}
                    >
                      <button
                        className=" text-gray-600 bg-transparent hover:bg-gray-100 hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
                        onClick={closeDoctorHandel}
                      >
                        <IoCloseOutline />
                      </button>
                      <DoctorDetails doctor={selectedDoctor} />
                    </motion.div>
                  </>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {selectedPatientNew && (
                  <>
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      className=" bg-black/5 absolute w-[calc(100%+65px)] h-full top-0 -left-[65px] z-40"
                    ></motion.div>
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      className={`bg-white shadow-md rounded-none fixed right-0 top-0 h-full z-40 w-full lg:w-[calc(100%-322px)] xl:w-[calc(100%-322px)] 2xl:w-[calc(100%-30%)] `}
                    >
                      <button
                        className=" text-gray-600 bg-transparent hover:bg-gray-100 hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
                        onClick={closePateintHandel}
                      >
                        <IoCloseOutline />
                      </button>
                      <PatientProfilePage
                        patient={selectedPatientNew}
                        handleCreateBill={handleCreateBill}
                        handleCloseModal={closePateintHandel}
                      />
                    </motion.div>
                  </>
                )}
              </AnimatePresence>
            </div>

            {showBillingForm && (
              <BillingForm
                patientId={selectedPatientId}
                onClose={handleCloseBillingForm}
              />
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Layout;
